import wixLocation from 'wix-location';
import wixWindow from 'wix-window';
import { createStoreon } from 'storeon-velo';

import { moduleColor } from './moduleColor';
import { moduleBiEvents } from './moduleBiEvents';
import { moduleDevLogger } from './moduleDevLogger';

const isDev = wixWindow.viewMode === 'Preview' || wixLocation.query.dev === 'true';

export const { connect, connectPage, dispatch, getState } = createStoreon([
    moduleColor,
    moduleBiEvents,
    isDev && moduleDevLogger,
]);
